module.exports = __webpack_public_path__ + "img/presentation03.352a98fa.jpg";